import React from "react";
import { useEffect } from "react";
import ClientSection from "../components/clientSection.jsx";
import MainHero from "../components/MainHero.jsx";
import SliderComponent from "../components/sliderComponent.jsx";
import Whyus from "../images/interiorDesginUttardhoka.jpeg";
import Gallery from "../components/Gallery.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingWheat } from "@fortawesome/free-solid-svg-icons";
import { faCompassDrafting } from '@fortawesome/free-solid-svg-icons';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { faCubes } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router";
import Construction from "../images/ourWorksConstruction.jpeg";
import Concrete from "../images/ourWorksConcrete.jpeg";
import Electrical from "../images/ourWorksElectrical.jpeg";
import Interior from "../images/ourWorksInterior.jpeg";

import "../styles/home.css";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div>
      <MainHero />
      <section className="why-choose-us">
        <div className="container">
          <div className="row">
            <div className="col-md-8 why-us-content">
              <div className="why-above-img">
                <h2>Why Choose Us</h2>
                <div className="after-line"></div>
                <p>
                  Our suite of integrated construction services ensure the highest degree of quality, safety, efficiency and innovation on your projects.<br /><br />
                  When you partner with BFCS Pvt.Ltd, you not only get innovative solutions, you get our fully
                  vested team and a commitment to doing things right. Our relentless focus on success leads to
                  smarter more collaborative building practices.<br /><br />
                  No matter the challenge, we build on what we know works and elevate your vision of success
                </p>
                <div className="why-button">
                  <Link to='/about-us' className="why-us-button">Know More</Link>
                </div>
              </div>
            </div>
            <div className=" col-md-4 why-us-image">
              <img src={Whyus} alt="about us" />
            </div>
          </div>
        </div>
      </section>
      {/* Our Work section */}
      <section className="our-works">
        <div className="container">
          <div className="row">
            <div className="col-md-12 works-title">
              <h2 className="works-title">Our Works</h2>
              <div className="after-line"></div>
            </div>
            <div className="col-md-3 works-content">
              <div className="works-first-section">
                <div className="logo-works">
                  <FontAwesomeIcon icon={faBuildingWheat} />
                </div>
              </div>
              <div className="works-text">
                <h5>Construction</h5>
                <Link to="/service">
                  <img src={Construction} alt="Construction" class="works-image" />
                </Link>
                {/* <p>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolore explicabo eius, quibusdam praesentium enim repudiandae
                  officiis perferendis necessitatibus eligendi cumque autem
                  velit quae dolorem cupiditate aspernatur optio ipsum cum
                  ducimus.
                </p> */}
              </div>
            </div>
            <div className="col-md-3 works-content">
              <div className="works-first-section">
                <div className="logo-works">
                  <FontAwesomeIcon icon={faCompassDrafting} />
                </div>
              </div>
              <div className="works-text">
                <h5>Interior Design</h5>
                <Link to="/service">
                  <img src={Interior} alt="Construction" class="works-image" />
                </Link>
                {/* <p>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolore explicabo eius, quibusdam praesentium enim repudiandae
                  officiis perferendis necessitatibus eligendi cumque autem
                  velit quae dolorem cupiditate aspernatur optio ipsum cum
                  ducimus.
                </p> */}
              </div>
            </div>
            <div className="col-md-3 works-content">
              <div className="works-first-section">
                <div className="logo-works">
                  <FontAwesomeIcon icon={faLightbulb} />
                </div>
              </div>
              <div className="works-text">
                <h5>Electrical</h5>
                <Link to="/service">
                  <img src={Electrical} alt="Construction" class="works-image" />
                </Link>
                {/* <p>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolore explicabo eius, quibusdam praesentium enim repudiandae
                  officiis perferendis necessitatibus eligendi cumque autem
                  velit quae dolorem cupiditate aspernatur optio ipsum cum
                  ducimus.
                </p> */}
              </div>
            </div>
            <div className="col-md-3 works-content">
              <div className="works-first-section">
                <div className="logo-works">
                  <FontAwesomeIcon icon={faCubes} />
                </div>
              </div>
              <div className="works-text">
                <h5>Concrete Work</h5>
                <Link to="/service">
                  <img src={Concrete} alt="Construction" class="works-image" />
                </Link>
                {/* <p>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolore explicabo eius, quibusdam praesentium enim repudiandae
                  officiis perferendis necessitatibus eligendi cumque autem
                  velit quae dolorem cupiditate aspernatur optio ipsum cum
                  ducimus.
                </p> */}
              </div>
            </div>
            <div className="col-md-12 read-more-works">
              <Link to='/service' className="read-more-button">View All Works</Link>
            </div>
          </div>
        </div>
      </section>
      <section className="client-render">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ClientSection />
            </div>
          </div>
        </div>
      </section>
      <section className="featured-products">
        <h2 className="section-title">Featured Projects</h2>
        <Gallery />
      </section>
      <SliderComponent />
    </div>
  );
};

export default Home;
